<script lang="ts">
    // types
    import type { Readable } from 'svelte/store';
    import type { RaceInterface } from '../interfaces';
    import { intcomma } from 'journalize';
    import { formatPercent } from '../utils/format.js';
  
    /** @type {import('../types.d').ReadableRace} */
    export let feed;
  
  
    let alwaysShowCandidates = 4;
    let shouldSortCandidates = false;
    let voteLabel = 'total';
    let hidePrecincts = false;
  
    $: caption = $feed.race_type === 'G' ? `` : $feed.seat_name;
    const raceId = $feed.id;
    const captionNote = $feed.description;
    $: candidates = $feed.candidates;
    $: totalVotes = $feed.total_votes;
    $: office = $feed.office;
    const precinctsReportingPercent = $feed.precincts_reporting_percent;
    $: eevp = $feed.eevp;
    const numOfwinners = $feed.number_of_winners;
    $: numberOfCandidates = candidates.length;
    $: tooFewToHide = numberOfCandidates <= alwaysShowCandidates + 1;
  
    let viewAllCandidates = false;
  
    const isBallotMeasure = office === 'I';
  
    $: preppedCandidates = shouldSortCandidates
      ? candidates.sort((a, b) => descending(a.votes, b.votes))
      : candidates;
  
    $: numDecimalsInPercent = raceId === 'GA-S12301-2020-11-03' ? 3 : undefined;
  
  </script>
  
  <div class="contest mt-0">
    <table class="contest__candidates">
  
      <!-- HEADER -->
      <thead>
        <tr>
          <th scope="col" colSpan={1} class="contest__candidate-header" />
          <th scope="col" colSpan="1" class="contest__candidate-header"> 
          </th>
          <th scope="col" class="contest__candidate-header text-left">
            <span>% votes</span>
          </th>
          <th scope="col" class="contest__candidate-header text-left">
            {voteLabel}
          </th>
        </tr>
      </thead>
  
      <tbody>
        {#each preppedCandidates as candidate, idx (candidate.ap_id)}
          <tr
            class="candidate contest__candidate-row contest__candidate-row-{candidate.party}"
            hidden={!(
              viewAllCandidates ||
              tooFewToHide ||
              idx < alwaysShowCandidates
            )}
          >
            <th
              scope="row"
              class="candidate__cell candidate__cell-name"
              class:candidate__cell-name-winner={candidate.is_winner |
                candidate.is_runoff}
            >
              {#if candidate.is_winner}
                <span class="candidate__cell-winner candidate__{candidate.party}" aria-label="checkmark, winner">
                  ✓
                </span>
              {/if}
            </th>
            <th
              scope="row"
              class="candidate__cell candidate__cell-name"
              class:candidate__cell-name-winner={candidate.is_winner |
                candidate.is_runoff}
            >
              {#if candidate.given_name}{candidate.given_name}{/if}
              {candidate.family_name}
            </th>
  
            <td
              class="candidate__cell candidate__cell-pct candidate__cell-pct-{candidate.is_winner
                ? 'w'
                : 'l'} {candidate.isWinner ? 'text-medium' : ''} text-left"
              class:candidate__cell-ballot-measures={isBallotMeasure}
            >
              <div>
                <span
                  class="candidate__pct-bar candidate__pct-bar-{candidate.family_name.toLowerCase()} "
                  style="width: {formatPercent(candidate.votes,totalVotes,numDecimalsInPercent)}%"
                />
                  {formatPercent(candidate.votes, totalVotes, numDecimalsInPercent)}
                <span class="candidate__pct-symbol">%</span>
              </div>
            </td>
  
            <td
              class="candidate__cell candidate__cell-votes text-right"
              class:candidate__cell-ballot-measures={isBallotMeasure}
            >
              {intcomma(candidate.votes)}
            </td>
          </tr>
        {/each}
        {#if !tooFewToHide}
          <tr class="candidate contest__candidate-row">
            <th colspan="4" scope="row" class="candidate__cell p-0" >
              <button on:click={() => (viewAllCandidates = !viewAllCandidates)}>
                View
                {viewAllCandidates ? 'fewer' : 'all'}
                candidates
                <svg
                  class="icon"
                  class:icon-angle-down={!viewAllCandidates}
                  class:icon-angle-up={viewAllCandidates}
                >
                  <use
                    xlink:href="#{viewAllCandidates
                      ? 'icon-angle-up'
                      : 'icon-angle-down'}"
                  />
                </svg>
              </button>
            </th>
          </tr>
        {/if}
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3" class="contest__precincts text-left">
            {#if !hidePrecincts}
              {#if (eevp >= 0) && (eevp !==null)}
                {eevp}% of expected vote in
              {/if}
            {/if}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>